/* eslint-disable no-unused-vars */
export enum AuthActionType {
  SIGNIN = 'signin',
  SIGNIN_SUCCESS = 'signin_success',
  SIGNIN_FAILURE = 'signin_failure',
}
